// ── Site Content Data ──────────────────────────────────────────────────────

export const NAV_LINKS = [
  { label: 'Home',       href: '/' },
  { label: 'About',      href: '/about' },
  { label: 'Services',   href: '/services' },
  { label: 'Industries', href: '/industries' },
  { label: 'Contact',    href: '/contact' },
];

export const HERO_SLIDES = [
  {
    tag: 'ATE & Probe Card',
    heading: 'Experience World-class ATE & Probe Card Design',
    sub: 'Precision-engineered test boards for semiconductor validation.',
  },
  {
    tag: 'High-Speed PCB',
    heading: 'High-Speed Design — Changing The World One Trace At A Time',
    sub: 'Multi-gigabit signal integrity for next-generation electronics.',
  },
  {
    tag: 'Library Development',
    heading: 'Library Development & Support — State Of The Art Footprint',
    sub: 'Accurate, production-ready component libraries for any EDA platform.',
  },
  {
    tag: 'Signal Integrity',
    heading: 'Signal & Power Integrity — Reshape Your First Turn',
    sub: 'In-depth SI/PI analysis ensuring zero rework on complex designs.',
  },
  {
    tag: 'Verification',
    heading: 'Verification Services — An Agile Way Forward',
    sub: 'Comprehensive functional and timing verification for ASIC designs.',
  },
];

export const STATS = [
  { value: '32+',   label: 'Years in Business' },
  { value: '120+',  label: 'Design Engineers' },
  { value: '4',     label: 'Strategic Locations' },
  { value: '24/7',  label: 'Support Available' },
  { value: '98%',   label: 'Customer Retention' },
];

export const SERVICES = [
  {
    icon: '⚡',
    title: 'ATE Board Design',
    short: 'Automatic Test Equipment',
    desc: 'World-class Automatic Test Equipment board design for semiconductor testing with unmatched speed and accuracy.',
    color: '#2563a8',
  },
  {
    icon: '🔬',
    title: 'High-Speed Design',
    short: 'Multi-Gigabit Signals',
    desc: 'Cutting-edge high-speed PCB design tackling SI/PI challenges that change the world one trace at a time.',
    color: '#0ea5e9',
  },
  {
    icon: '📚',
    title: 'Library Development',
    short: 'Component Libraries',
    desc: 'State-of-the-art component library development and support — an example of the art on footprint precision.',
    color: '#06b6d4',
  },
  {
    icon: '🧠',
    title: 'ASIC Flow',
    short: 'Chip-Level Design',
    desc: 'Complete ASIC design flow from RTL to GDSII. DWB sees it as anatomy when the world sees it as a chip.',
    color: '#7c3aed',
  },
  {
    icon: '📡',
    title: 'RF Design',
    short: 'Radio Frequency',
    desc: 'High-frequency RF board design for advanced wireless communication and radar systems.',
    color: '#2563a8',
  },
  {
    icon: '✅',
    title: 'Verification Services',
    short: 'Agile Verification',
    desc: 'An agile way of verification services — ensuring design correctness at every stage of development.',
    color: '#059669',
  },
  {
    icon: '📊',
    title: 'Signal & Power Integrity',
    short: 'SI / PI Analysis',
    desc: 'Reshape your first-turn success with comprehensive signal and power integrity analysis.',
    color: '#0ea5e9',
  },
  {
    icon: '🔋',
    title: 'Voltage & Current Analysis',
    short: 'Power Analysis',
    desc: 'Comprehensive voltage and current analysis ensuring reliable power delivery across all layers.',
    color: '#d97706',
  },
  {
    icon: '🤖',
    title: 'Automated & Manual DFM',
    short: 'Design For Manufacturing',
    desc: 'Reimagine the way you automate DFM — combining AI-assisted rules with expert manual review.',
    color: '#06b6d4',
  },
  {
    icon: '💻',
    title: 'IT Software Services',
    short: 'Software Solutions',
    desc: 'The software soul of the hardware world — custom IT and software services for PCB operations.',
    color: '#2563a8',
  },
  {
    icon: '🔄',
    title: 'EDA Conversion',
    short: 'Tool Migration',
    desc: 'Seamless EDA tool migration and data conversion — move between platforms without losing fidelity.',
    color: '#7c3aed',
  },
  {
    icon: '🏭',
    title: 'Procurement, Fab & Assembly',
    short: 'End-to-End Supply',
    desc: 'End-to-end procurement, PCB fabrication and board assembly — from BOM to boxed product.',
    color: '#059669',
  },
];

export const INDUSTRIES = [
  { icon: '✈️', name: 'Aerospace',          desc: 'Mission-critical boards for avionics and satellite systems.' },
  { icon: '🚗', name: 'Automotive',          desc: 'AEC-Q100 qualified designs for ADAS and EV platforms.' },
  { icon: '🏥', name: 'Medical & Healthcare', desc: 'IPC Class 3 boards for implantable and diagnostic devices.' },
  { icon: '🛡️', name: 'Defense',             desc: 'MIL-spec PCB design for radar, comms, and weapons systems.' },
  { icon: '💾', name: 'Semiconductor',        desc: 'Probe cards and load boards for wafer-level testing.' },
];

export const CONTACT_INFO = {
  phone: '+91 98945-20497',
  email: 'sales@dwbtech.com',
  web:   'dwbtech.com',
  support: '24/7 Global Support',
};

export const ABOUT_BULLETS = [
  'One of the only PCB board designers specialising in ATE, Probe Cards and Application Boards.',
  'Committed to highest-grade products for clients with no compromise in quality at affordable cost.',
  '24-hour global support — our customers are never left waiting.',
  'Equal importance and value given to every customer, large or small.',
  'Leading vendor for the design of Test Board Units with strong industry background.',
];

export const SERVICE_CATEGORIES = [
  {
    id: 'pcb-hardware',
    label: 'PCB & Hardware',
    icon: '🔧',
    accent: '#2563a8',
    tagline: 'Precision-Engineered Board Design',
    description: 'From ATE test boards to ultra-dense HDI designs, our PCB & Hardware division delivers world-class printed circuit board solutions for semiconductor, defence, and industrial applications.',
    services: [
      {
        title: 'ATE Board Design',
        short: 'Automatic Test Equipment',
        slug: 'ate-board-design',
        icon: '⚡',
        desc: 'World-class ATE board design for semiconductor validation — load boards, probe cards, and interface boards engineered for multi-GHz test environments.',
        image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&q=70',
      },
      {
        title: 'Probe Card',
        short: 'Wafer-Level Test Probing',
        slug: 'probe-card',
        icon: '🔍',
        desc: 'Precision probe card design for wafer-level testing — cantilever, vertical, and MEMS probe technologies for advanced semiconductor nodes.',
        image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=600&q=70',
      },
      {
        title: 'HSD & HDI PCB Designs',
        short: 'High-Speed & High-Density Interconnect',
        slug: 'hsd-hdi-pcb-design',
        icon: '🔬',
        desc: 'DDR5, PCIe Gen 5, 100GbE and microvia HDI designs — controlled impedance routing and full SI/PI simulation for first-pass success.',
        image: 'https://images.unsplash.com/photo-1517077304055-6e89abbf09b0?w=600&q=70',
      },
      {
        title: 'MLO/MLC Substrate Design Services',
        short: 'Multi-Layer Organic & Ceramic Substrates',
        slug: 'mlo-mlc-substrate-design',
        icon: '🧱',
        desc: 'Advanced MLO and MLC substrate design for chip-scale packaging, RF modules, and high-frequency semiconductor applications.',
        image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&q=70',
      },
      {
        title: 'EDA Conversion',
        short: 'Tool Migration',
        slug: 'eda-conversion',
        icon: '🔄',
        desc: 'Verified EDA platform migration — with net-list fidelity guaranteed by written SLA.',
        image: 'https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=600&q=70',
      },
      {
        title: 'RF Design',
        short: 'Radio Frequency Engineering',
        slug: 'rf-design',
        icon: '📡',
        desc: 'DC to 77 GHz RF board design — Rogers substrates, antenna arrays, and EM simulation for wireless and radar applications.',
        image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=600&q=70',
      },
      {
        title: 'Library Development and Maintenance',
        short: 'Component Libraries & Footprints',
        slug: 'library-development',
        icon: '📚',
        desc: 'IPC-7351 compliant symbols, footprints, and 3D models— delivered in 24 hours.',
        image: 'https://images.unsplash.com/photo-1456406644174-8ddd4cd52a06?w=600&q=70',
      },
      {
        title: 'DFM / DFT Analysis',
        short: 'Design For Manufacturing & Test',
        slug: 'dfm-dft-analysis',
        icon: '🤖',
        desc: '200+ rule automated DFM checks combined with expert manual review — zero field-escape rate on manufacturing defects.',
        image: 'https://images.unsplash.com/photo-1617788138017-80ad40651399?w=600&q=70',
      },
      {
        title: 'Procurement & Assembly',
        short: 'End-to-End Supply Chain',
        slug: 'procurement-assembly',
        icon: '🏭',
        desc: 'BOM to boxed product — global component sourcing, IPC Class 3 fabrication, SMT assembly, AOI, X-ray, and functional test.',
        image: 'https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=600&q=70',
      },
      {
        title: 'Signal & Power Integrity',
        short: 'SI / PI Analysis',
        slug: 'signal-power-integrity',
        icon: '📊',
        desc: 'Pre- and post-layout SI/PI simulation, PDN analysis, eye diagram verification, and EMI pre-compliance scanning.',
        image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=70',
      },
      {
        title: 'CAM Validation and Editing',
        short: 'CAM Data Review & Correction',
        slug: 'cam-validation-editing',
        icon: '🛠️',
        desc: 'Expert CAM data validation and editing — Gerber, ODB++, and IPC-2581 review to ensure fabrication-ready output every time.',
        image: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=600&q=70',
      },
    ],
  },

  {
    id: 'chip-asic',
    label: 'Chip & ASIC',
    icon: '🧠',
    accent: '#7c3aed',
    tagline: 'Silicon Design from RTL to GDSII',
    description: 'Our Chip & ASIC division covers the complete semiconductor design flow — from RTL architecture and functional verification through physical implementation and tapeout at leading foundries.',
    services: [
      {
        title: 'ASIC Design Flow',
        short: 'RTL to GDSII',
        slug: 'asic-flow',
        icon: '🧠',
        desc: 'Complete ASIC design flow — RTL coding, synthesis, STA, place-and-route, and GDSII tapeout on TSMC, GF, and Samsung nodes.',
        image: 'https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=600&q=70',
      },
      {
        title: 'Verification Services',
        short: 'UVM Functional Verification',
        slug: 'verification-services',
        icon: '✅',
        desc: 'UVM testbench development, formal property verification, protocol verification, and coverage closure for complex SoC designs.',
        image: 'https://images.unsplash.com/photo-1576086213369-97a306d36557?w=600&q=70',
      },
    ],
  },

  // ── Mechanical Division with sub-groups ──────────────────────────────
{
  id: 'mechanical',
  label: 'Mechanical Division',
  icon: '⚙️',
  accent: '#0f766e',
  tagline: 'Precision Mechanical Engineering for Semiconductor',
  description: 'Our Mechanical Division specialises in semiconductor handling, EMS, automation, and precision machine building — delivering high-precision mechanical assemblies that interface seamlessly with automated test environments.',

  // Only TRUE sub-groups (Semiconductor and Wiring Harness)
  groups: [
    {
      label: 'Semiconductor',
      icon: '💾',
      services: [
        {
          title: 'Turn Key Solution Provider',
          short: 'Complete Mechanical Systems',
          slug: 'turn-key-solution',
          icon: '🔑',
          desc: 'End-to-end mechanical system design and manufacturing — from concept and CAD modelling through fabrication, assembly, and on-site commissioning.',
          image: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=600&q=70',
        },
        {
          title: 'Wafer Cassette',
          short: 'Semiconductor Wafer Handling',
          slug: 'wafer-cassette',
          icon: '💿',
          desc: 'Precision-engineered wafer cassettes and FOUP-compatible carriers for 200mm and 300mm wafer handling in cleanroom environments.',
          image: 'https://images.unsplash.com/photo-1569852573858-03c9e2877792?w=600&q=70',
        },
        {
          title: 'Pogo Tower',
          short: 'Spring Pin Contact Systems',
          slug: 'pogo-tower',
          icon: '🏗️',
          desc: 'High-density pogo pin tower assemblies engineered for reliable electrical contact in ATE load board and probe card test environments.',
          image: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=600&q=70',
        },
        {
          title: 'Interface',
          short: 'Test Interface Assemblies',
          slug: 'interface',
          icon: '🔌',
          desc: 'Custom interface boards and mechanical interface assemblies connecting device under test (DUT) boards to ATE platforms with precision alignment.',
          image: 'https://images.unsplash.com/photo-1601933470096-0e34634ffcde?w=600&q=70',
        },
        {
          title: 'Hinge, Manipulator & Cart',
          short: 'Test Head Handling Equipment',
          slug: 'hinge-manipulator-cart',
          icon: '🦾',
          desc: 'Ergonomic test head manipulators, docking hinges, and equipment carts designed to reduce operator fatigue and improve test cell efficiency.',
          image: 'https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=600&q=70',
        },
        {
          title: 'Test Head Chassis Design & Mfg',
          short: 'Custom Test Head Enclosures',
          slug: 'test-head-chassis',
          icon: '🖥️',
          desc: 'Structural design and precision manufacturing of test head chassis — aluminium and steel enclosures engineered for signal integrity and thermal management.',
          image: 'https://images.unsplash.com/photo-1591639713936-6fafe6748de0?w=600&q=70',
        },
      ],
    },
    {
      label: 'Wiring Harness',
      icon: '🔌',
      services: [
        {
          title: 'Semiconductor / EMS Industries',
          short: 'Test & Handler Cable Assemblies',
          slug: 'semiconductor-ems',
          icon: '💾',
          desc: 'High-density cable assemblies and interconnects for semiconductor test handlers, wafer probers, and EMS production systems — built to IPC-A-620 Class 3.',
          image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&q=70',
        },
        {
          title: 'Automation / Machine Building',
          short: 'Industrial Cable Harnesses',
          slug: 'automation-machine-building',
          icon: '🤖',
          desc: 'Rugged cable harnesses for industrial automation, CNC machinery, and robotic systems — rated for continuous flexing, high-vibration, and harsh environments.',
          image: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=600&q=70',
        },
        {
          title: 'Defense / Military',
          short: 'MIL-Spec Wiring Harnesses',
          slug: 'defense-military',
          icon: '🛡️',
          desc: 'MIL-DTL-17 and MIL-DTL-27500 compliant harnesses for ground vehicles, avionics, and naval systems — shock, vibration, and temperature rated.',
          image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=600&q=70',
        },
        {
          title: 'Aerospace',
          short: 'Aerospace Cable Assemblies',
          slug: 'aero-space',
          icon: '✈️',
          desc: 'Lightweight, high-reliability cable assemblies for commercial and defence aerospace — AS9100 quality standards, fire-resistant jacketing, and full traceability.',
          image: 'https://images.unsplash.com/photo-1436891620584-47fd0e565afb?w=600&q=70',
        },
        {
          title: 'Medical',
          short: 'Medical-Grade Cable Assemblies',
          slug: 'medical',
          icon: '🏥',
          desc: 'Biocompatible, sterilisable cable assemblies for diagnostic equipment, surgical robots, and patient monitoring systems — ISO 13485 compliant.',
          image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&q=70',
        },
        {
          title: 'Telecom',
          short: 'High-Frequency RF Assemblies',
          slug: 'telecom',
          icon: '📶',
          desc: 'Low-loss RF cable assemblies, fibre optic harnesses, and structured cabling solutions for 5G base stations, data centres, and telecom infrastructure.',
          image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&q=70',
        },
      ],
    },
  ],

  // Direct main services (shown as cards immediately, no group click needed)
  directServices: [
    {
      title: 'EMS Mobile Assembly',
      short: 'Electronics Manufacturing Services',
      slug: 'ems-mobile-assembly',
      icon: '📱',
      desc: 'Full EMS mobile assembly services — SMT, through-hole, and mixed-technology board assembly for consumer electronics and industrial products.',
      image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=600&q=70',
    },
    {
      title: 'High Precision Machine Shop',
      short: 'CNC Machining & Fabrication',
      slug: 'high-precision-machine-shop',
      icon: '🏭',
      desc: 'State-of-the-art CNC machining, turning, milling, and grinding — tolerances to ±0.005mm for semiconductor and defence applications.',
      image: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=600&q=70',
    },
    {
      title: 'On Site Service Support (OSS)',
      short: 'Field Engineering Support',
      slug: 'on-site-service-support',
      icon: '🛠️',
      desc: 'Dedicated on-site engineering support for semiconductor equipment installation, maintenance, and troubleshooting at your facility.',
      image: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=600&q=70',
    },
  ],

  get services() {
    return [
      ...this.directServices,
      ...this.groups.flatMap(g => g.services),
    ];
  },
},

  {
    id: 'smt',
    label: 'SMT',
    icon: '🏗️',
    accent: '#be185d',
    tagline: 'Surface Mount Technology Assembly',
    description: 'DWB Tech operates high-capacity SMT lines delivering fully automated, high-accuracy PCB assembly for prototype through production volumes.',
    services: [
      {
        title: 'Fully Automated Assembly',
        short: 'End-to-End SMT Automation',
        slug: 'fully-automated-assembly',
        icon: '🤖',
        desc: 'Fully automated SMT assembly lines with solder paste inspection, pick-and-place, reflow, AOI, and X-ray — zero manual handling for consistent quality.',
        image: 'https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=600&q=70',
      },
      {
        title: '3-Line SMT Support',
        short: 'Multi-Line Production Capacity',
        slug: 'three-line-smt-support',
        icon: '🏭',
        desc: 'Three dedicated SMT production lines enabling parallel runs, fast changeovers, and uninterrupted production scheduling for high-volume customers.',
        image: 'https://images.unsplash.com/photo-1609081219090-a6d81d3085bf?w=600&q=70',
      },
      {
        title: '90,000 CPH Capacity',
        short: 'High-Throughput Placement',
        slug: 'smt-cph-capacity',
        icon: '⚡',
        desc: '90,000 components per hour placement capacity — supporting high-mix, high-volume production with fast turnaround and zero-defect targets.',
        image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&q=70',
      },
    ],
  },

  {
    id: 'it-software',
    label: 'IT Software Services',
    icon: '💻',
    accent: '#0ea5e9',
    tagline: 'The Software Soul of the Hardware World',
    description: 'Our IT Software division builds custom digital solutions for electronics and semiconductor companies — from EDA automation tools and IoT platforms to full-stack web and mobile applications.',
    services: [
      {
        title: 'Web App Development',
        short: 'Custom Web Applications',
        slug: 'web-app-development',
        icon: '🌐',
        desc: 'React, Next.js, Node.js — scalable web applications purpose-built for electronics workflows, EDA integrations, and engineering portals.',
        image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=600&q=70',
      },
      {
        title: 'Software Application Dev',
        short: 'Custom Software Solutions',
        slug: 'software-application-dev',
        icon: '🖥️',
        desc: 'Desktop tools, EDA automation scripts, and MES/PLM integrations — software built by engineers who understand your hardware workflows.',
        image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=600&q=70',
      },
      {
        title: 'Mobile App Development',
        short: 'iOS & Android Applications',
        slug: 'mobile-app-development',
        icon: '📱',
        desc: 'Offline-first factory floor apps, IoT dashboards, and inventory systems for iOS and Android — built for industrial environments.',
        image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=600&q=70',
      },
      {
        title: 'Cloud App Development',
        short: 'Cloud-Native Applications',
        slug: 'cloud-app-development',
        icon: '☁️',
        desc: 'AWS, Azure, GCP — microservices, serverless architecture, and CI/CD pipelines for scalable, secure cloud applications.',
        image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&q=70',
      },
      {
        title: 'Embedded Software Dev',
        short: 'Firmware & Embedded Systems',
        slug: 'embedded-software-dev',
        icon: '⚙️',
        desc: 'Bare-metal C/C++, FreeRTOS, and embedded Linux — firmware written by engineers who designed the hardware it runs on.',
        image: 'https://images.unsplash.com/photo-1597852074816-d933c7d2b988?w=600&q=70',
      },
    ],
  },
];